import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1C1B1F",
  d: "M10 20 0 10 10 0l1.775 1.775L3.55 10l8.225 8.225L10 20Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };